import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="temoignage" className="bg-soft-gray py-20 md:py-28">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-8">
          <i className="ri-double-quotes-l text-copper text-2xl" />
        </div>

        <blockquote className="text-slate-primary text-lg md:text-xl lg:text-2xl leading-relaxed font-manrope font-medium mb-8">
          {t('temoignage_quote')}
        </blockquote>

        <div className="flex items-center justify-center gap-4">
          <div className="w-12 h-12 rounded-full bg-copper flex items-center justify-center">
            <span className="text-white font-bold text-sm">FB</span>
          </div>
          <div className="text-left">
            <p className="text-slate-primary font-semibold text-sm">{t('temoignage_author')}</p>
            <p className="text-slate-primary/50 text-xs">{t('temoignage_city')} — {t('temoignage_detail')}</p>
          </div>
        </div>

        <p className="text-slate-primary/40 text-xs mt-6 italic">
          {t('temoignage_disclaimer')}
        </p>
      </div>
    </section>
  );
}